import React, {Component} from "react";
import {reloadAppIfClientAndServerVersionsDiffer} from "../services/AppVersionService";
import {Link} from "react-router-dom";

export class LearnPage extends Component {
    componentDidMount() {
        reloadAppIfClientAndServerVersionsDiffer();
    }

    render() {
        let {children, title, backUrl, backTitle} = this.props;
        return <div className="container">
            <div className="row">
                <div className="col-sm">
                    {title ? <h2>
                        {backUrl ? <span><Link to={backUrl}>{backTitle}</Link> / </span> : null}
                        {title}
                    </h2> : null}
                </div>
            </div>
            {children}
        </div>;
    }
}

